import "../../components/Suggestionbox/suggest.css";
import Modal from "react-bootstrap/Modal";
import { Col, Row, Card } from "react-bootstrap";
import ClearIcon from "@mui/icons-material/Clear";
import { images } from "../../constants";
import { useState } from "react";
import { publishImage } from "../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { getAsset } from "../../helpers/helper";
import url from "../../config/axios";
import { FailedNotify, SuccessNotify } from "../../constants/tostify";
import { useSelector } from "react-redux";

const Reportselectezibox = ({
  selectezireport,
  setSelectezireport,
  shopid,
}) => {
  const { name } = useSelector((state) => state.user);

  const [shopOwner, setShopOwner] = useState({
    shopId: shopid ? shopid : "",
    userId: name._id,
    reportType: "",
    description: "",
    status: "",
    image: [], // must be array
  });

  // preview images
  const [displayimg, setDisplayimg] = useState([]); // must be array

  // upload progress
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  // ========================
  // SUBMIT REPORT
  // ========================
  const HandlePost = () => {
    const payload = { ...shopOwner };
    if (!payload.shopId) {
      delete payload.shopId;
    }

    url
      .post("reportselectezi/", payload)
      .then((res) => {
        if (res.data.message === "Report added successfully") {
          SuccessNotify("Report Send Successfully");
          setSelectezireport(false);
          setShopOwner((prev) => ({ ...prev, image: [] }));
          setDisplayimg([]);
        }
      })
      .catch(() => {
        FailedNotify("Failed to send Try Again!");
      });
  };

  // ========================
  // INPUT HANDLER
  // ========================
  const ShopHandler = (event) => {
    setShopOwner((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  // ========================
  // IMAGE UPLOAD HANDLER
  // ========================
  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(1); // force progress bar to appear immediately

      const uploadedImages = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });

      // append images instead of replacing
      setShopOwner((prev) => ({
        ...prev,
        image: [...prev.image, ...uploadedImages],
      }));

      setDisplayimg((prev) => [...prev, ...uploadedImages]);

      // keep 100% visible briefly
      setTimeout(() => {
        setUploadProgress(0);
        setIsUploading(false);
      }, 800);
    } catch (error) {
      setIsUploading(false);
      setUploadProgress(0);
      FailedNotify("Failed! Try Again");
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: { "image/*": [] },
    multiple: true,
    onDrop,
  });

  // ========================
  // REMOVE IMAGE
  // ========================
  const removeImage = (index) => {
    setDisplayimg((prev) => prev.filter((_, i) => i !== index));
    setShopOwner((prev) => ({
      ...prev,
      image: prev.image.filter((_, i) => i !== index),
    }));
  };

  return (
    <>
      <Modal
        size="lg"
        show={selectezireport}
        onHide={() => setSelectezireport(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        centered
        scrollable
        dialogClassName="customer-support-report-modal"
      >
        <Modal.Header closeButton className="bg-blue-lg">
          <Modal.Title id="example-modal-sizes-title-lg">
            <h5 className="text-center text-white">Report to Selectezi Team</h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="customer-support-report-content">
            <Row>
              <Col xs={12} className="text-start">
                <h6>Please Select a Problem to Continue</h6>
                <p className="shop-profile-para">Select a problem</p>
                <Col xs={12} md={8}>
                  <select
                    className="form-select input-style p-2"
                    name="reportType"
                    onChange={ShopHandler}
                    defaultValue=""
                  >
                    <option value="" disabled>
                      Select Option
                    </option>
                    <option>Report Against a Bug</option>
                    <option>Report Against a User</option>
                    <option>Report Against a Shop</option>
                  </select>
                </Col>
              </Col>
            </Row>

            <label className="form-label mt-2 font-weight-bold font_11">
              Report Description*
            </label>
            <textarea
              className="form-control input-style"
              rows="8"
              style={{ border: "1px solid #C4C4C4" }}
              placeholder="Type your message here.."
              name="description"
              onChange={ShopHandler}
            ></textarea>

            <div className="row customer-support-report-upload mt-2">
              <div className="col-12 ps-3">
                <h6>Add Screenshots*</h6>

                {/* Upload Progress */}
                {uploadProgress > 0 && (
                  <div className="mt-2">
                    <small>Uploading: {uploadProgress}%</small>
                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        style={{ width: `${uploadProgress}%` }}
                      />
                    </div>
                  </div>
                )}

                <div className="row mt-2">
                  <Col lg="12">
                    <Row>
                      {/* Upload Button */}
                      <Col lg={3} md={3} className="mt-2 ms-1">
                        <Card
                          style={{ width: "6rem", height: "6rem" }}
                          {...getRootProps()}
                          className="dropzone"
                        >
                          <Card.Img
                            className="imet-fit"
                            src={images.AddImage}
                          />
                          <Card.Body>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              {...getInputProps()}
                            />
                          </Card.Body>
                        </Card>
                      </Col>

                      {/* Preview Images */}
                      {displayimg.length > 0 && (
                        <Col lg={8} md={8} className="mt-1 d-flex flex-wrap">
                          {displayimg.map((image, index) => (
                            <Card
                              key={index}
                              className="me-2 mt-1 position-relative"
                              style={{
                                width: "6rem",
                                height: "6rem",
                                border: "2px solid",
                              }}
                            >
                              <Card.Img
                                className="imet-fit upload-img mt-0"
                                src={getAsset(image)}
                                alt=""
                                crossOrigin="anonymous"
                              />
                              <div
                                className="close-btnone"
                                onClick={() => removeImage(index)}
                              >
                                <ClearIcon />
                              </div>
                            </Card>
                          ))}
                        </Col>
                      )}
                    </Row>
                  </Col>
                </div>
              </div>

              <div className="customer-support-report-actions">
                <button
                  type="button"
                  className="btn-red-sm"
                  onClick={() => setSelectezireport(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn-blue-sm"
                  onClick={HandlePost}
                  disabled={isUploading}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Reportselectezibox;
